// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* analytics styling */

.analyticsMainHeading.MuiTypography-root {
  font-weight: 700;
  padding: 10px 0;
  font-size: 28px;
  width: 400px;
  height: 36px;
  line-height: 36px;
}

.businessUnitModal .MuiPaper-root.MuiDialog-paper {
  width: 640px;
  border-radius: 16px;
  height: auto;
}

.displayDirectionRow {
  display: flex;
}

.font-black-high.MuiTypography-root {
  color: var(--text-high, rgba(1, 1, 2, 0.72)) !important;
}

.font-black-highest.MuiTypography-root {
  color: var(--text-highest, rgba(1, 1, 2, 0.92)) !important;
}

.font-black-highest.MuiTableCell-root {
  color: var(--text-highest, rgba(1, 1, 2, 0.92)) !important;
}

.font-black-medium.MuiTypography-root {
  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;
}

.font-neutral-grey.MuiTypography-root {
  color: var(--Global-Neutral-Grey-1200, #1d1c20) !important;
}

.font-black-medium.MuiTableCell-root {
  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;
}

.font-green {
  color: var(--generic-primary, #24b7aa) !important;
}

.font-orange {
  color: rgba(173, 78, 0, 1) !important;
}

.font-black-85 {
  color: var(--character-primary-85, rgba(0, 0, 0, 0.85)) !important;
}

.font-darkRed.MuiTypography-root {
  color: var(--comms-negative, #b9232f) !important;
}

.font-darkYellow.MuiTypography-root {
  color: #9e5707 !important;
}

.font-darkblue.MuiTypography-root {
  color: #1890FF !important;
}

.font-darkGreen.MuiTypography-root {
  color: var(--comms-positive, #0b6a48) !important;
}

.font-light-grey.MuiTypography-root {
  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;
}

.font-text-low {
  color: var(--text-low, rgba(1, 1, 2, 0.45)) !important;
}

.font-link {
  color: var(--global-purple-900, #403e9f) !important;
}

.font-gray {
  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;
}

.tabHeading.MuiButtonBase-root.MuiTab-root {
  color: var(--text-low, rgba(1, 1, 2, 0.45));
  font-size: 18px;
  /* font-style: normal; */
  font-weight: 500;
  line-height: 22px;
  text-transform: none;
  max-width: fit-content;
  font-family: "Poppins";
}

.MuiTabs-indicator {
  display: flex;
  height: 2px;
  align-items: flex-start;
  gap: 10px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 4px;
  background: var(--generic-primary-accent, #403e9f);
}

/* common typography styling */

.headerH1Bold.MuiTypography-root {
  font-family: Poppins;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  /* 128.571% */
  letter-spacing: -0.336px;
}

.MuiTypography-root.headerH1Medium {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
  /* Header/H1 Medium */
  font-family: Poppins;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
  /* 128.571% */
  letter-spacing: -0.336px;
}

.headerH2Bold.MuiTypography-root {
  /* Header/H2 - Bold */
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.288px;
}

.headerH2Medium.MuiTypography-root {
  /* Header/H2 - Bold */
  font-family: "Poppins";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  /* 133.333% */
  letter-spacing: -0.288px;
}

.headerH3Bold.MuiTypography-root {
  /* Header/H3 Bold */
  font-size: 20px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.24px;
}

.SemiboldTwenty.MuiTypography-root {
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.4px;
}

.semiboldSixteen.MuiTypography-root {
  color: var(--Global-Neutral-Grey-1300, #0a090b);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.18px;
}

.headerH3Medium.MuiTypography-root {
  /* Header/H3 Medium */
  font-size: 20px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.24px;
}

.subHeaderSemiBold.MuiTypography-root {
  /* Sub Header/Semi bold */
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
}

.subHeaderMedium.MuiTypography-root {
  /* Sub Header/Medium */
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}

.bodyB1SemiBold.MuiTypography-root {
  /* Body/B1 Semi bold */
  font-size: 16px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.bodyB1Medium.MuiTypography-root {
  /* Body/B1 Medium */
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.bodyB1Medium.MuiTableCell-root {
  /* Body/B1 Medium */
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  font-family: "Poppins";
}

.bodyB1MediumColored.MuiTableCell-root.MuiTypography-root {
  /* Body/B1 Medium */
  color: var(--text-high, rgba(1, 1, 2, 0.72));
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  font-family: "Poppins";
}

.bodyB2SemiBold.MuiTypography-root {
  /* Body/B2 Semi bold */
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
}

.bodyB2SemiBoldColored.MuiTypography-root {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
  /* Body/B2 Semi bold */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  /* 128.571% */
}

.bodyB2SemiBold {
  /* Body/B2 Semi bold */
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
}

.bodyB2Medium.MuiTypography-root {
  /* Body/B2 Medium */
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}

.bodyB2MediumColored.MuiTypography-root {
  /* Body/B2 Medium */
  color: var(--text-high, rgba(1, 1, 2, 0.72));
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  font-family: "Poppins";
}

.bodyB2RegularText.MuiTypography-root {
  /* Body/B2 Regular */
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.bodyB2RegularText.MuiFormLabel-root.MuiInputLabel-root {
  /* Body/B2 Regular */
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.bodyB2Medium.MuiTableCell-root {
  /* Body/B2 Medium */
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  font-family: "Poppins";
}

.labelSemiBold.MuiTypography-root {
  /* Label/Semi bold */
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
}

.MuiTypography-root.labelSemiBoldColored {
  /* Label/Semi bold */
  color: var(--text-medium, rgba(1, 1, 2, 0.6));
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
}

.labelSemiBold.MuiTableCell-root {
  /* Label/Semi bold */
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
}

.labelMedium.MuiTypography-root {
  /* Label/Medium */
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}

.labelRegular.MuiTypography-root {
  /* Label/Regular */
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}

.labelSmall.MuiTypography-root {
  /* Label/Regular */
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
}

.labelRegularColored.MuiTypography-root {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}

.b1Regular.MuiTypography-root {
  /* B1 Regular */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 137.5% */
  letter-spacing: -0.18px;
}

/* media query */
@media screen and (min-width: 1440px) {
  .b1Regular.MuiTypography-root {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
}

@media (min-width: 1280px) and (max-width: 1439px) {
  .b1Regular.MuiTypography-root {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    min-width: max-content;
  }
}

.table td,
.table th {
  padding-left: 10px !important;
  padding-right: -4px !important;

  vertical-align: middle;
}

.timeline-subtitles {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 30px;
}

.orderManagement .MuiBox-root {
  padding: 32px 0px 0px 0px !important;
}

.tableHeader.MuiTableCell-root {
  color: var(--Global-Neutral-Grey-900, #7f7d83);

  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  /* 150% */
}

.tableContent.MuiTableCell-root {
  color: var(--Global-Neutral-Grey-1300, #0a090b);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 0px 12px 12px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

.kpi-conatiner {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 30px;
}

.enabledColor .MuiInputAdornment-root {
  margin-right: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/analytics/analytics.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA,8BAA8B;;AAE9B;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA;;EAEE,6BAA6B;EAC7B,8BAA8B;;EAE9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;;EAE9C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,+CAA+C;EAC/C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* analytics styling */\n\n.analyticsMainHeading.MuiTypography-root {\n  font-weight: 700;\n  padding: 10px 0;\n  font-size: 28px;\n  width: 400px;\n  height: 36px;\n  line-height: 36px;\n}\n\n.businessUnitModal .MuiPaper-root.MuiDialog-paper {\n  width: 640px;\n  border-radius: 16px;\n  height: auto;\n}\n\n.displayDirectionRow {\n  display: flex;\n}\n\n.font-black-high.MuiTypography-root {\n  color: var(--text-high, rgba(1, 1, 2, 0.72)) !important;\n}\n\n.font-black-highest.MuiTypography-root {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92)) !important;\n}\n\n.font-black-highest.MuiTableCell-root {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92)) !important;\n}\n\n.font-black-medium.MuiTypography-root {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;\n}\n\n.font-neutral-grey.MuiTypography-root {\n  color: var(--Global-Neutral-Grey-1200, #1d1c20) !important;\n}\n\n.font-black-medium.MuiTableCell-root {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;\n}\n\n.font-green {\n  color: var(--generic-primary, #24b7aa) !important;\n}\n\n.font-orange {\n  color: rgba(173, 78, 0, 1) !important;\n}\n\n.font-black-85 {\n  color: var(--character-primary-85, rgba(0, 0, 0, 0.85)) !important;\n}\n\n.font-darkRed.MuiTypography-root {\n  color: var(--comms-negative, #b9232f) !important;\n}\n\n.font-darkYellow.MuiTypography-root {\n  color: #9e5707 !important;\n}\n\n.font-darkblue.MuiTypography-root {\n  color: #1890FF !important;\n}\n\n.font-darkGreen.MuiTypography-root {\n  color: var(--comms-positive, #0b6a48) !important;\n}\n\n.font-light-grey.MuiTypography-root {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;\n}\n\n.font-text-low {\n  color: var(--text-low, rgba(1, 1, 2, 0.45)) !important;\n}\n\n.font-link {\n  color: var(--global-purple-900, #403e9f) !important;\n}\n\n.font-gray {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6)) !important;\n}\n\n.tabHeading.MuiButtonBase-root.MuiTab-root {\n  color: var(--text-low, rgba(1, 1, 2, 0.45));\n  font-size: 18px;\n  /* font-style: normal; */\n  font-weight: 500;\n  line-height: 22px;\n  text-transform: none;\n  max-width: fit-content;\n  font-family: \"Poppins\";\n}\n\n.MuiTabs-indicator {\n  display: flex;\n  height: 2px;\n  align-items: flex-start;\n  gap: 10px;\n  flex-shrink: 0;\n  align-self: stretch;\n  border-radius: 4px;\n  background: var(--generic-primary-accent, #403e9f);\n}\n\n/* common typography styling */\n\n.headerH1Bold.MuiTypography-root {\n  font-family: Poppins;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 36px;\n  /* 128.571% */\n  letter-spacing: -0.336px;\n}\n\n.MuiTypography-root.headerH1Medium {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n  /* Header/H1 Medium */\n  font-family: Poppins;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 36px;\n  /* 128.571% */\n  letter-spacing: -0.336px;\n}\n\n.headerH2Bold.MuiTypography-root {\n  /* Header/H2 - Bold */\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px;\n  letter-spacing: -0.288px;\n}\n\n.headerH2Medium.MuiTypography-root {\n  /* Header/H2 - Bold */\n  font-family: \"Poppins\";\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n  /* 133.333% */\n  letter-spacing: -0.288px;\n}\n\n.headerH3Bold.MuiTypography-root {\n  /* Header/H3 Bold */\n  font-size: 20px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 700;\n  line-height: 28px;\n  letter-spacing: -0.24px;\n}\n\n.SemiboldTwenty.MuiTypography-root {\n  font-family: Poppins;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 120%;\n  letter-spacing: -0.4px;\n}\n\n.semiboldSixteen.MuiTypography-root {\n  color: var(--Global-Neutral-Grey-1300, #0a090b);\n  font-family: Poppins;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.18px;\n}\n\n.headerH3Medium.MuiTypography-root {\n  /* Header/H3 Medium */\n  font-size: 20px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 500;\n  line-height: 28px;\n  letter-spacing: -0.24px;\n}\n\n.subHeaderSemiBold.MuiTypography-root {\n  /* Sub Header/Semi bold */\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n}\n\n.subHeaderMedium.MuiTypography-root {\n  /* Sub Header/Medium */\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px;\n}\n\n.bodyB1SemiBold.MuiTypography-root {\n  /* Body/B1 Semi bold */\n  font-size: 16px;\n  font-family: Poppins;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.bodyB1Medium.MuiTypography-root {\n  /* Body/B1 Medium */\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.bodyB1Medium.MuiTableCell-root {\n  /* Body/B1 Medium */\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  font-family: \"Poppins\";\n}\n\n.bodyB1MediumColored.MuiTableCell-root.MuiTypography-root {\n  /* Body/B1 Medium */\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  font-family: \"Poppins\";\n}\n\n.bodyB2SemiBold.MuiTypography-root {\n  /* Body/B2 Semi bold */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px;\n}\n\n.bodyB2SemiBoldColored.MuiTypography-root {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n  /* Body/B2 Semi bold */\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px;\n  /* 128.571% */\n}\n\n.bodyB2SemiBold {\n  /* Body/B2 Semi bold */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px;\n}\n\n.bodyB2Medium.MuiTypography-root {\n  /* Body/B2 Medium */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.bodyB2MediumColored.MuiTypography-root {\n  /* Body/B2 Medium */\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  font-family: \"Poppins\";\n}\n\n.bodyB2RegularText.MuiTypography-root {\n  /* Body/B2 Regular */\n  font-family: \"Poppins\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.bodyB2RegularText.MuiFormLabel-root.MuiInputLabel-root {\n  /* Body/B2 Regular */\n  font-family: \"Poppins\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.bodyB2Medium.MuiTableCell-root {\n  /* Body/B2 Medium */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  font-family: \"Poppins\";\n}\n\n.labelSemiBold.MuiTypography-root {\n  /* Label/Semi bold */\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 14px;\n}\n\n.MuiTypography-root.labelSemiBoldColored {\n  /* Label/Semi bold */\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 14px;\n}\n\n.labelSemiBold.MuiTableCell-root {\n  /* Label/Semi bold */\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 14px;\n}\n\n.labelMedium.MuiTypography-root {\n  /* Label/Medium */\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n}\n\n.labelRegular.MuiTypography-root {\n  /* Label/Regular */\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n}\n\n.labelSmall.MuiTypography-root {\n  /* Label/Regular */\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.labelRegularColored.MuiTypography-root {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n}\n\n.b1Regular.MuiTypography-root {\n  /* B1 Regular */\n  font-family: Poppins;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px;\n  /* 137.5% */\n  letter-spacing: -0.18px;\n}\n\n/* media query */\n@media screen and (min-width: 1440px) {\n  .b1Regular.MuiTypography-root {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n  }\n}\n\n@media (min-width: 1280px) and (max-width: 1439px) {\n  .b1Regular.MuiTypography-root {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    min-width: max-content;\n  }\n}\n\n.table td,\n.table th {\n  padding-left: 10px !important;\n  padding-right: -4px !important;\n\n  vertical-align: middle;\n}\n\n.timeline-subtitles {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 30px;\n}\n\n.orderManagement .MuiBox-root {\n  padding: 32px 0px 0px 0px !important;\n}\n\n.tableHeader.MuiTableCell-root {\n  color: var(--Global-Neutral-Grey-900, #7f7d83);\n\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px;\n  /* 150% */\n}\n\n.tableContent.MuiTableCell-root {\n  color: var(--Global-Neutral-Grey-1300, #0a090b);\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 0px 12px 12px 0px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 300px;\n}\n\n.kpi-conatiner {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  column-gap: 30px;\n}\n\n.enabledColor .MuiInputAdornment-root {\n  margin-right: 0px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
